import API from "utils/API";
import Broker from "typedef/Broker";
import LoanOfficer from "typedef/LoanOfficer";
import { useParams, useSearchParams } from "react-router-dom";
import React, { ReactNode, useContext, useEffect, useState } from "react";

type InviteContextType = {
  code?: string;
  phone?: string;
  email?: string;
  broker?: Broker;
  lastName?: string;
  firstName?: string;
  addressLine?: string;
  loanOfficerId?: string;
  borrowerFullName?: string;
  loanOfficer?: LoanOfficer;
};

export const InviteContext = React.createContext<InviteContextType | undefined>(
  {}
);

export const useInvite = () => {
  return useContext(InviteContext);
};

export const InviteCustomerContextProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [invite, setInvite] = useState<InviteContextType>();

  const brokerName = params["brokerName"];
  const loName = params["loName"];

  useEffect(() => {
    if (brokerName && loName) {
      API.get<InviteContextType>(
        `/get-borrower-invite?brokerName=${brokerName}&loName=${loName}`
      ).then((res) => {
        if ("error" in res) {
          console.error(res);
        } else {
          setInvite(res.data);
        }
      });
    }
  }, [params, brokerName, loName]);

  const typeUser = brokerName && loName ? "borrower" : "coborrower";

  useEffect(() => {
    const code = searchParams.get("code");

    if (code && typeUser) {
      API.get<InviteContextType>(`/get-${typeUser}-invite?code=${code}`).then(
        (res) => {
          if ("error" in res) {
            console.error(res);
          } else {
            setInvite(res.data);
          }
        }
      );
    }
  }, [searchParams, typeUser]);

  return (
    <InviteContext.Provider value={invite}>{children}</InviteContext.Provider>
  );
};

export default useInvite;
